import api from '../../api/index'

const propertyApiService = {
  async fetchPropertyById (propertyId) {
    const urlEnd = `/v2/properties/${propertyId}`
    const method = 'get'
    const response = await api.asyncRequest(urlEnd, method)
    return response.ok ? response.data : null
  },
  async fetchPropertyBuildings (propertyId) {
    const urlEnd = `/v2/properties/openlink/${propertyId}`
    const method = 'get'
    const response = await api.asyncRequest(urlEnd, method)
    return response.ok ? response.data : null
  },
  async fetchPropertyMarkers (propertyId) {
    const urlEnd = `/v2/properties/${propertyId}/allMarkers`
    const method = 'get'
    const response = await api.asyncRequest(urlEnd, method)
    return response.ok ? response.data : null
  },
  async fetchPropertyCompanys (propertyId) {
    const urlEnd = `/v2/properties/${propertyId}/allCompanies`
    const method = 'get'
    const response = await api.asyncRequest(urlEnd, method)
    return response.ok ? response.data : null
  }
}

export default propertyApiService
